import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { base64Validator, numberValidator, WRAPPED_AES_CRYPTO_KEY_BASE64_LENGTH, } from '#validation';
import { SALT_BASE64_MAX_LENGTH, SALT_BASE64_MIN_LENGTH, } from '#validation/user/constants';
import { scramStoredDataSchema } from '../scram';
export const userCryptoStoredDataSchema = z.object({
    userCryptoKey: base64Validator({
        requiredError: 'internal.key.required',
        length: {
            len: WRAPPED_AES_CRYPTO_KEY_BASE64_LENGTH,
            error: 'internal.key.length',
        },
        invalidFormatError: 'internal.key.base64',
    }),
    userCryptoKeySalt: base64Validator({
        requiredError: 'internal.salt.required',
        minLength: {
            min: SALT_BASE64_MIN_LENGTH,
            error: 'internal.salt.minLength',
        },
        maxLength: {
            max: SALT_BASE64_MAX_LENGTH,
            error: 'internal.salt.maxLength',
        },
        invalidFormatError: 'internal.salt.base64',
    }),
    userCryptoKeyIterations: numberValidator({
        requiredError: 'internal.key.iterations.required',
    }),
});
export class UserCryptoDto extends createZodDto(userCryptoStoredDataSchema) {
}
export const userIdentitySchema = userCryptoStoredDataSchema.extend(scramStoredDataSchema.shape);
export class UserIdentityDto extends createZodDto(userIdentitySchema) {
}
export const ssoUserIdentitySchema = userCryptoStoredDataSchema.pick({
    userCryptoKey: true,
    userCryptoKeySalt: true,
});
export class SsoUserIdentityDto extends createZodDto(userIdentitySchema) {
}
